// extracted by mini-css-extract-plugin
export default {"section":"LoveStory_section__dXnIi","container":"LoveStory_container__G9mJw","container__photo":"LoveStory_container__photo__Xg8uH","photo":"LoveStory_photo__8DBWI"};